export default function PHP_getNamespaces() {
  return (
    <div>
      <h1>PHP_getNamespaces</h1>
    </div>
  );
}
